// extracted by mini-css-extract-plugin
module.exports = {"stories":"_36wXxLNI9ZFOQM_bxvGUuI"};